<template>
  <div class="all" >
    <div class="header">
      <div class="header_wrap">
        <img src="../assets/quickfix/logo.png" alt>
        <span>Quick</span>
        <span>
          Fix.
          <span style="font-size:18px">工具中心</span>
        </span>
      </div>
    </div>
    <div class="main">
      <div class="content">
        <div class="nag">
          <el-button type="primary" @click="toindex" >查看已有工具列表</el-button>
        </div>
        <div style="margin-top:30px">
          <el-input type="textarea" v-model="value.content" :rows="12" placeholder="若有工具需求，请尽快告诉我们吧~限1000字"></el-input>
        </div>
        <div style="margin-top:20px;display:flex;">
            <span style="display:inline-block;width:88px;line-height:40px">联系方式：</span>  
            <el-input type="text" v-model="value.contact"  :rows="12" placeholder="请输入您的联系方式，例如QQ、邮箱、电话号码"></el-input>
        </div>
        <div style="margin-top:40px;text-align:center">
            <el-button type="primary" style="width:150px" @click="add">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import{addReply}from '@/api/forout.js'
export default {
  data() {
    return {
       value:{
         content:null,
         contact:null
       }
    };
  },
  methods: {
      toindex(){
          // this.$router.push('/index')
           window.location.href="http://iknow.lenovo.com/detail/dc_172545.html"
      },
      add(){
        if(this.value.content.length<5){
          alert('需求详情描述不能少于5个字')
          return
        }
        if(this.value.content.length>1000){
          alert('需求详情描述不能大于1000个字')
          return
        }
        addReply(this.value).then(res=>{
          if(res.data.code==200){
            alert('提交成功！')
            this.$router.push('/index')
          }else{
            alert(res.data.message)
          }
        })
        
      }
  },
};
</script>
<style lang="scss" scoped>
.header {
  height: 120px;
  background: #4da7f8;
  box-shadow: 5px 0 25px 0 #ddd;
  color: #fff;
  text-align: center;
  line-height: 70px;
  padding-top: 30px;
  box-sizing: border-box;
  font-size: 38px;
  // font-weight: bold;
  margin: 0 -8px;
  .header_wrap {
    position: relative;
    width: 1160px;
    margin: 0 auto;
    img{
      position: absolute;
      left: 0;
    }
    > span {
      margin-left: 10px;
    }
  }
}
.all {
  background: #eff5fa;
  padding-bottom: 10px;
  min-height: 100%;
}
.main {
  width: 1160px;
  margin: 0 auto;
  .content {
    margin: 30px 0px;
    background: #fff;
    padding: 40px 60px;
    .nag {
      text-align: right;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/needs.vue